import React from "react";

import { ZERO_GUID } from "@/lib/format";

/** Бейдж характеристики в карточках номенклатуры проверки заказов.
 *
 * Нет характеристики — бейдж «без характеристики», а не пустое место: 16.10.2026
 * (заказ 00НФ-002118) в заказе был гель с характеристикой OZON FRESH, а на
 * паллете раскладки — тот же гель БЕЗ неё. Отсутствие бейджа глаз не замечает,
 * и две строки читались как одна. Показываем на ВСЕХ товарах (решение
 * владельца), не выясняя, бывают ли у номенклатуры характеристики вообще.
 *
 * Пунктир и курсив — чтобы «без характеристики» не спутать с характеристикой,
 * которая так называется.
 *
 * `characteristicRef` — когда вызывающий его знает: ссылка есть, а имени нет
 * (не дорезолвилось) — это НЕ «без характеристики», показываем начало ссылки.
 */
export function CharacteristicBadge({
  name,
  characteristicRef,
}: {
  name?: string | null;
  characteristicRef?: string | null;
}): React.ReactElement {
  const label = (name ?? "").trim();
  if (label) {
    return <span className="rounded border bg-white px-1 text-[10px]">{label}</span>;
  }
  const ref = characteristicRef && characteristicRef !== ZERO_GUID ? characteristicRef : "";
  if (ref) {
    return (
      <span className="rounded border bg-white px-1 font-mono text-[10px]" title={ref}>
        хар. {ref.slice(0, 8)}
      </span>
    );
  }
  return (
    <span className="rounded border border-dashed border-slate-400 bg-white px-1 text-[10px] italic text-slate-500">
      без характеристики
    </span>
  );
}
